import { useTranslation } from "@/src/i18n/client";
import { ShowDecenterAlert } from "./Decenterd";
import { IFormData } from "@/src/productDetails/Rx/RxForm";
import { FmDialog } from "@/ui-component";

export interface IAlert {
    message: string;
    nextStep: any;
    usage: any;
    usageDetail: any;
    productInfo: any;
    id: any;
    open: boolean;
}
const ShowAlert = ({
    message,
    nextStep,
    usage,
    usageDetail,
    productInfo,
    id,
    open,
}: IAlert) => {
    const { t } = useTranslation("lens");
    return (
        <FmDialog
            open={open}
            bottom={{
                ok: t("lens:DECENTERED_CANCEL"),
                onOk: () => {
                    window.location.href = `${window.location.origin}/pc/specific-glasses?usage=${usage}&usageDetail=${usageDetail}&categoriesId=${productInfo.master_categories_id}&id=${id}`;
                },
                cancel: t("lens:CONTINUE"),
                onCancel: () => {
                    nextStep?.();
                },
            }}
        >
            {message}
        </FmDialog>
    );
};

export interface IH5ShowDecenterAlert {
    rx: IFormData;
    productInfo: Record<string, any>;
    usage: string;
    usageDetail: string;
    isDecenter: () => void;
    nextStep: () => void;
    id: number;
    open: boolean;
}
const H5ShowDecenterAlert = (props: Partial<IH5ShowDecenterAlert>) => {
    //整理参数
    const { open, ...restProps } = props;
    return (
        <ShowDecenterAlert
            {...restProps}
            alert={(prop: IAlert) => <ShowAlert {...prop} />}
        />
    );
};

export { H5ShowDecenterAlert };
